import { EllipsisOutlined } from '@ant-design/icons';
import { WrapperAction } from '../ActionIcon';

const Options = ({
  onClick,
  className,
  ...props
}: {
  onClick?: (...args: unknown[]) => unknown;
  className?: string;
  [key: string]: unknown;
}) => {
  return (
    <WrapperAction {...{ onClick, ...props }}>
      <EllipsisOutlined className={className || 'cursor-pointer p-1 text-xl'} />
    </WrapperAction>
  );
};

export default Options;
